<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 16:43:32
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-13 18:34:50
-->
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="item in levelList" :key="item.label">
        <span v-if="!item.path" class="no-redirect">
          {{ item.label }}
        </span>
        <a v-else @click.prevent="handleLink(item)">
          {{ item.label }}
        </a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
  import { mapState } from 'pinia'
  import { pinias } from '@main/common/pinia'

  const { login } = pinias
  export default {
    data() {
      return {
        levelList: null
      }
    },
    computed: {
      ...mapState(login, ['permissionsMenu'])
    },
    watch: {
      $route(route) {
        if (route.path.startsWith('/redirect/')) {
          return
        }
        this.getBreadcrumb()
      }
    },
    created() {
      this.getBreadcrumb()
    },
    methods: {
      getBreadcrumb() {
        const result = { label: this.$route.meta.title, path: this.$route.path }
        this.levelList = []
        let breadList = []
        if (this.$route.meta?.parentTitle) {
          breadList = JSON.parse(JSON.stringify(this.$route.meta.parentTitle))
        }
        breadList.push(result)
        const tempMap = new Map()
        for (const item of breadList) {
          if (!tempMap.has(item.label)) {
            tempMap.set(item.label, item)
          }
        }
        this.times = setTimeout(() => {
          this.levelList = [...tempMap.values()]
          clearTimeout(this.times)
          this.times = null
        }, 100)

        //   // only show routes with meta.title
        //   let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
        //   const first = matched[0]

        //   this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        //   const tempMap = new Map();
        //   for (const item of this.levelList) {
        //     if (!tempMap.has(item.meta.title)) {
        //       tempMap.set(item.meta.title,item)
        //     }
        //   }
        //   this.levelList = [...tempMap.values()]
      },
      isDashboard(route) {
        const name = route && route.name
        if (!name) {
          return false
        }
        return name.trim() === 'Index'
      },
      handleLink(item) {
        const { path } = item
        this.$router.push(path)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    font-size: 14px;
    line-height: 30px;
    display: inline-block;
    padding-left: 26px;
    border-left: 1px solid #fff;

    .no-redirect {
      cursor: text;
      color: #97a8be;
    }
  }
</style>
<style lang="scss">
  .app-breadcrumb {
    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      color: #fff;
    }
  }

  .fixed-header .el-breadcrumb__inner a,
  .el-breadcrumb__inner a:hover,
  .el-breadcrumb__inner.is-link:hover {
    color: #97a8be;
  }

  .fixed-header .el-breadcrumb__inner a,
  .fixed-header .el-breadcrumb__inner.is-link {
    font-weight: 500;
    color: #97a8be;
  }
</style>
